import { ApiService } from './index'
import { User, LoginCredentials, RegisterData, ForgotPasswordData, ResetPasswordData, ApiResponse } from '@types'

export interface AuthTokens {
  user: User
  access: string
  refresh: string
}

export const authApi = {
  signIn: (credentials: LoginCredentials) =>
    ApiService.post<ApiResponse<AuthTokens>>('auth/login/', credentials),

  signUp: (userData: RegisterData) =>
    ApiService.post<ApiResponse<AuthTokens>>('auth/register/', userData),

  signOut: (refresh?: string | null) =>
    ApiService.post('auth/logout/', refresh ? { refresh } : {}),

  // Exchange a refresh token for a fresh access token. ROTATE_REFRESH_TOKENS
  // is enabled server-side, so the response also carries a new refresh token
  // and the presented one is blacklisted.
  refresh: (refresh: string) =>
    ApiService.post<ApiResponse<{ access: string; refresh?: string }>>('auth/refresh/', { refresh }),

  validateUser: () =>
    ApiService.get<ApiResponse<User>>('auth/profile/'),

  forgotPassword: (data: ForgotPasswordData) =>
    ApiService.post<ApiResponse<{ message: string }>>('auth/password/reset/', data),

  resetPassword: (data: ResetPasswordData) =>
    ApiService.post<ApiResponse<{ message: string }>>('auth/password/reset/confirm/', data),

  resendVerification: (email: string) =>
    ApiService.post<ApiResponse<{ message: string }>>('auth/resend-verification/', { email }),

  updateUser: (userData: Partial<User>) =>
    ApiService.put<ApiResponse<User>>('auth/profile/update/', userData),

  deleteUser: () =>
    ApiService.delete<ApiResponse<{ message: string }>>('auth/profile/'),

  googleAuth: (token: string) =>
    ApiService.post<ApiResponse<AuthTokens>>('auth/google/', { token }),
}
